export function dateTodayTimestamp(): number {
  return new Date().setHours(0, 0, 0, 0);
}
